import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../../../graphql/types.generated';
export type UpdateAccountNameMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateManagedAccountTradingNameInput;
}>;

export type UpdateAccountNameMutationResult = { __typename?: 'Mutation' } & {
  updateManagedAccountTradingName?: GraphQLTypes.Maybe<
    { __typename?: 'UpdateManagedAccountTradingNamePayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const UpdateAccountNameDocument = gql`
  mutation updateAccountName($input: UpdateManagedAccountTradingNameInput!) {
    updateManagedAccountTradingName(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
